import React from 'react'
import classNames from 'classnames'

interface Organization {
  id: string
  name: string
  active: boolean
}

interface AdminUserOrganizationProps {
  organization: Partial<Organization>
}

const AdminUserOrganization: React.FC<AdminUserOrganizationProps> = ({
  organization,
}) => {
  const orgStatus = organization.active ? 'paying' : 'free'

  return (
    <span className="admin-user-organization">
      <span className="admin-user-org-sub">
        {organization.name}
        <span
          className={classNames('admin-org-status', `admin-org-${orgStatus}`)}
        >
          {orgStatus}
        </span>
      </span>
    </span>
  )
}

export default AdminUserOrganization
